// extracted by mini-css-extract-plugin
export default {"row-layout":"styles__row-layout--A+3Wi","range":"styles__range--d4+uX","row-item":"styles__row-item--Gkq4y","half":"styles__half--B-xvs","description":"styles__description--iSVPn"};